import React, { useEffect } from "react";

const Close = () => {
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.innerHTML = "document.location.href = '/close'";
    document.head.appendChild(s);
  }, []);

  return <></>;
};

export default Close;
